import { CommonErrorCode, DataRoleErrorCode, FlowErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { DataRoleContentType } from '../models/ContentTypes';
import { IDataRoleBase } from '../models/IDataRoleInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Module } from '../Module';
import { IErrorDetail } from './ContentActionNotification';
import { ContentUrl } from './ContentUrl';

export class DataRoleErrors {

  public static $inject = ['$translate', 'ContentUrl'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private ContentUrl: ContentUrl) { }

  public errorDetailsFor(dataRoleErrorItem: IErrorItem<IDataRoleBase>): IErrorDetail {
    return {
      itemName: dataRoleErrorItem.item.name,
      itemUrl:
      dataRoleErrorItem.error.code === CommonErrorCode.DataRoleNotFound
          ? null
          : this.ContentUrl.forItem(dataRoleErrorItem.item, DataRoleContentType),
      errorMessage: this.errorMessageFor(dataRoleErrorItem)
    };
  }

  public errorMessageFor(errorItem: IErrorItem<IDataRoleBase>) {
    const dataRole = errorItem.item;
    switch (errorItem.error.code) {
      case CommonErrorCode.DataRoleNotFound:
        return this.$translate.instant('errorDataRoleNotFound', { DATA_ROLE_NAME: L10n.elideIfLong(dataRole.name) });
      case DataRoleErrorCode.DataRoleWithSameNameInDestinationProject:
        return this.$translate.instant('errorDataRoleNameAlreadyExists');
      case DataRoleErrorCode.DataRoleDestinationProjectNotFound:
        return this.$translate.instant('errorDataRoleDestinationProjectNotFound');
      case CommonErrorCode.CallingUserInsufficientPermissions:
      case DataRoleErrorCode.DataRoleMoveInsufficientPermissionsOnDestinationProject:
        return this.$translate.instant('errorDataRoleInsufficientPermissions');
      default:
        return this.$translate.instant('errorUnknown');
    }
  }
}

Module.instance().service('DataRoleErrors', DataRoleErrors);
